import * as React from 'react';
import { Sidebar } from '@/components/organisms/sidebar';
import { Header } from '@/components/organisms/header';
import { useFeatureFlags } from '@/lib/feature-flags';
import { useSubscriptionSync } from '@/lib/subscription';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  // Initialize feature flags on dashboard load
  useFeatureFlags();

  // Sync subscription data to store
  useSubscriptionSync();

  return (
    <div className="flex h-dvh w-full overflow-hidden">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <div className="flex-1 flex flex-col min-h-0 min-w-0 w-full">
        {/* Header */}
        <Header />

        {/* Page content */}
        <main className="flex-1 overflow-y-auto bg-muted/30 p-4 md:p-6 pb-safe w-full">
          {children}
        </main>
      </div>
    </div>
  );
}
